<content>
    <form [formGroup]="newEditForm" [ngClass]="{'show-error': showError}">
        <div class="info">{{ 'global.infoRequired' | translate}}</div>
        <div [ngClass]="this.isSmallScreen ? 'entry-5-modal' : 'entry-4-modal'">
            <label>{{'mantenimientoEnvases.envase.envase' | translate}} *</label>
            <input type="text" formControlName="des">
        </div>
        <div [ngClass]="this.isSmallScreen ? 'entry-5-modal' : 'entry-4-modal'" *ngIf="!envaseId || (envaseId && !this.registroEnUso) ">
            <label>{{'mantenimientoEnvases.envase.etiquetador' | translate}} *</label>
            <app-filterable-list class="shorter-list" [itemsList]="etiquetadores" [selectedItem]="newEditForm.get('etiquetador')" [placeHolder]="false">
            </app-filterable-list>
        </div>
        <div [ngClass]="this.isSmallScreen ? 'entry-5-modal' : 'entry-4-modal'" *ngIf="!envaseId || (envaseId && !this.registroEnUso)">
            <label>{{'mantenimientoEnvases.envase.kilos' | translate}} *</label>
            <input type="number" formControlName="kilos">
        </div>
        <div [ngClass]="this.isSmallScreen ? 'entry-5-modal' : 'entry-4-modal'" *ngIf="!envaseId || (envaseId && !this.registroEnUso)">
            <label>{{'mantenimientoEnvases.envase.unidadMedida' | translate}} *</label>
            <app-filterable-list [itemsList]="unidadesMedida" [selectedItem]="newEditForm.get('unidadMedida')" [placeHolder]="false">
            </app-filterable-list>
        </div>
    </form>
</content>
<footer class="button-bar-right">
    <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
    <button (click)="save()">{{envaseId ? ('global.actualizar' | translate) : ('global.insertar' | translate)}}</button>
</footer>

<app-toast *ngIf="(showError || showApiError) && mensajes" [messages]="mensajes" (closed)="showError=$event;showApiError=$event"></app-toast>
